// IE 2026 10 08 / ODOO-343741: прокси-полоса горизонтальной прокрутки превью печати в режиме склейки секций (AttrGridGroup).
// Секции склейки — отдельные гриды wijmo; по горизонтали они прокручиваются синхронно (mvt_bindScroll), а своя полоса была
// только у ПОСЛЕДНЕЙ секции — внизу содержимого обёртки .mvt-wrap: при высокой таблице её не видно, пока обёртку не прокрутишь
// по вертикали до конца. Прокси — отдельный тонкий скроллер, прилипший к нижнему краю обёртки (position: sticky; bottom: 0).
// Ход прокси = наибольший ход секций (scrollWidth − clientWidth корня грида); полоса нужна, только когда хоть одна секция
// шире окна. Секция уже самой широкой упирается в свой предел (так wijmo прижимает scrollLeft) — как и при Shift+колесе раньше.

// roots: [{ scrollWidth, clientWidth }] — корни гридов секций (div[wj-part='root'])
// → { maxScroll, show }: ход прокси, px (целое ≥ 0); show — нужна ли полоса
export function mvtHbar_geometry(roots) {
    let max = 0
    for (const r of roots || []) {
        const sw = Number(r?.scrollWidth), cw = Number(r?.clientWidth)
        if (!(sw > 0) || !(cw > 0)) continue   // скрытый (display: none) или несмонтированный грид — не в счёт
        if (sw - cw > max) max = sw - cw
    }
    max = Math.round(max)
    return { maxScroll: max, show: max > 0 }
}

// позиция прокси по секциям: xs — scrollPosition.x гридов секций (у wijmo ≤ 0); секция, упёршаяся в свой предел,
// отстаёт от самой широкой — берём наибольший сдвиг → scrollLeft прокси, px (целое, 0..maxScroll)
export function mvtHbar_left(xs, maxScroll) {
    let left = 0
    for (const x of xs || []) {
        const v = -Number(x)
        if (Number.isFinite(v) && v > left) left = v
    }
    const lim = Math.max(0, Number(maxScroll) || 0)
    return Math.round(Math.min(left, lim))
}
